import React from "react";
import { IoMdAlert } from "react-icons/io";
import "../../../src/style/block.scss";
import "./style.scss";

const ShopError: React.FC = () => {
  return (
    <div className="flex-center-center shop-error-page">
      <div className="shop-error shadow" role="alert">
        <span className="shop-error__icon" aria-hidden>
          <IoMdAlert />
        </span>
        <div className="shop-error__body">
          <h2 className="shop-error__title">Nie możemy pokazać tego sklepu</h2>
          <p className="shop-error__lead">
            Wygląda na to, że pod tym adresem nie ma aktywnego sklepu — albo odnośnik jest niepełny albo nieaktualny.
          </p>
          <p className="shop-error__hint">
            Sprawdź, czy link skopiowałeś w całości. Jeśli nadal widzisz ten komunikat, napisz lub zadzwoń do obiektu,
            który udostępnił Ci rezerwacje — poda Ci poprawny adres.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShopError;
